// @flow

import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import theme from '@theme';

const { colors } = theme;

export const StyledOuterModalWrapper = styled.div`
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed;
  background: rgba(0, 0, 0, 0.7);

  ${({ modalState }) => {
    const show = `
    visibility: visible;
    z-index: 1001;
    opacity: 1;
    transition: all .1s ease-in-out;
  `;

    const hide = `
   visibility: hidden;
    opacity: 0;
    z-index: -1;
    transition: all .1s ease-in-out;
  `;
    if (modalState) {
      return show;
    }

    return hide;
  }}
`;

export const StyledModalWrapper = styled.div`
  width: 700px;
  background-color: red;
  margin: 0;
  position: relative;
  top: 50%;
  left: 50%;

  ${({ modalState }) => {
    const show = `
    visibility: visible;
    transform: translate(-50%, -50%);
    z-index: 200;
    opacity: 1;
    transition: all .1s ease-in-out;
  `;

    const hide = `
    visibility: hidden;
    transform: translate(-40%, -50%);
    opacity: 0;
    z-index: -1;
    transition: all .1s ease-in-out;
  `;
    if (modalState) {
      return show;
    }

    return hide;
  }}

  ${breakpoint('mobile', 'desktop')`
   width: 90%;
   height: auto;
   max-height: 90vh;
   overflow-y: scroll;
   overflow-x: hidden;
   border-radius: 10px;
   background-color: white;

  > div {
    &:nth-child(1) {
      > div {
        &:nth-child(1) {
          width: 100%;
          margin: 0px;
          padding: 0 0px;
          margin: 0;
          top: 0;
        }
      }
    }
  }

  form{
    .styles__StyledFormGrid-sc-1b9in4c-13{
        margin-top: 0px;
        margin-bottom: 0px;
        padding: 0 5px;
      }
  }
 `}

 ${breakpoint('tablet', 'desktop')`
   height: auto;
   max-height: 75vh;
   width: 500px;
 `}

${breakpoint('desktop')`
      height: auto;
      overflow-y: overlay;
      overflow-x: hidden;
      max-height: 95vh;

      ::-webkit-scrollbar {
          width: 5px;
       }

       ::-webkit-scrollbar-track {
          background: ${colors.lightGray}; 
          border-radius: 10px;
       }
 

       ::-webkit-scrollbar-thumb {
          background: ${colors.translucentDarkBlue}; 
          border-radius: 10px;
       }

   border-radius: 10px;
   background-color: white;
    >div{
      &:nth-child(2){
       margin: auto;
      }
    }
  `}
`;

export const StyledIconWrapper = styled.div`
  width: 20px;
  height: 20px;
  z-index: 200;
  display: ${({ modalState }) => (modalState ? 'block' : 'none')};
  position: absolute;
  cursor: pointer;
  top: 8px;
  left: calc(100% - 28px);
  svg {
    width: 100%;
  }

  ${breakpoint('mobile', 'desktop')`
    position: sticky;
    height: 10px;
    width: 10px;
    left: calc(100% - 24px);
  `}
`;
